import React, { FunctionComponent } from 'react';

type LoaderProps = {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullHeight?: boolean;
  fullScreen?: boolean;
  className?: string;
};

const sizeClasses = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
  xl: 'w-16 h-16'
};

export const Loader: FunctionComponent<LoaderProps> = ({
  size = 'md',
  fullHeight = false,
  fullScreen = false,
  className = ''
}) => {
  const sizeClass = sizeClasses[size];

  const containerClasses = [
    'flex flex-col items-center justify-center',
    fullHeight && 'h-[60vh]',
    fullScreen && 'fixed inset-0 bg-white/90 backdrop-blur-sm z-[9999]',
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClasses}>
      <div className="relative">
        <div className={`${sizeClass} relative`}>
          {/* First ripple circle */}
          <div
            className="absolute inset-0 rounded-full border-2 animate-ping opacity-75"
            style={{
              borderColor: '#3b82f6',
              animationDuration: '2s',
              animationDelay: '0s'
            }}
          ></div>

          {/* Second ripple circle */}
          <div
            className="absolute inset-0 rounded-full border-2 animate-ping opacity-50"
            style={{
              borderColor: '#3b82f6',
              animationDuration: '2s',
              animationDelay: '-1s'
            }}
          ></div>

          {/* Center dot */}
          <div
            className={`${sizeClass} rounded-full opacity-20`}
            style={{ backgroundColor: '#3b82f6' }}
          ></div>
        </div>
      </div>

      {/* Default loading text */}
      <div className="mt-4 text-center">
        <p className="text-gray-600 text-sm">Cargando...</p>
      </div>
    </div>
  );
};
